import { defineComponent as m, ref as f, onMounted as y, computed as s, createElementBlock as b, openBlock as h, createElementVNode as a, normalizeStyle as l } from "vue";
import { _ } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const v = { class: "spinner-container" }, g = /* @__PURE__ */ m({
  __name: "Spinner.ce",
  props: {
    size: {
      type: Number,
      default: 40
    },
    thickness: {
      type: Number,
      default: 4
    },
    color: {
      type: String,
      default: "#D7D7D7"
    },
    secondaryColor: {
      type: String,
      default: "#FFFFFF"
    },
    duration: {
      type: Number,
      default: 1
    }
  },
  setup(c) {
    const e = c, o = f(0);
    let t = null;
    y(() => {
      let n = performance.now();
      const r = (i) => {
        const u = i - n;
        n = i, o.value = (o.value + u / (e.duration * 1e3) * 360) % 360, t = requestAnimationFrame(r);
      };
      return t = requestAnimationFrame(r), () => {
        t !== null && cancelAnimationFrame(t);
      };
    });
    const d = s(() => ({
      width: `${e.size}px`,
      height: `${e.size}px`
    })), p = s(() => ({
      width: "100%",
      height: "100%",
      borderWidth: `${e.thickness}px`,
      borderStyle: "solid",
      borderRadius: "50%",
      borderTopColor: e.color,
      borderRightColor: e.secondaryColor,
      borderBottomColor: e.secondaryColor,
      borderLeftColor: e.secondaryColor,
      transform: `rotate(${o.value}deg)`
    }));
    return (n, r) => (h(), b("div", v, [
      a("div", {
        class: "spinner",
        style: l(d.value)
      }, [
        a("div", {
          class: "spinner-circle",
          style: l(p.value)
        }, null, 4)
      ], 4)
    ]));
  }
}), C = ".spinner-container[data-v-86991295]{display:flex;align-items:center;justify-content:center;width:fit-content;height:fit-content}.spinner[data-v-86991295]{position:relative}.spinner-circle[data-v-86991295]{position:absolute;box-sizing:border-box}", S = /* @__PURE__ */ _(g, [["styles", [C]], ["__scopeId", "data-v-86991295"]]);
export {
  S as default
};
